import Vue from 'vue'
// import * as elementUI from 'element-ui'
import { Message, MessageBox, Loading } from 'element-ui'

var vm = new Vue();

export function showValidationMessage(valid,data){

    let validationMessageArray = [];
    for(var validPropertyName in data)
    {
        for(var i in data[validPropertyName])
        {
          validationMessageArray.push(data[validPropertyName][i].message);
        }
    }

    let newDatas = [];
    const createElement = vm.$createElement;
    for(let i in validationMessageArray){
      newDatas.push(createElement('p',null,validationMessageArray[i]));
    };


    MessageBox.alert(createElement('div',null, newDatas), "提示");
}

export function showValidationMessage_Text(msg){
  MessageBox.alert(msg, "提示");
}


// WEBPACK FOOTER //
// ./src/utils/uiHelper.js